// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__v1Bj+","container":"style_container__md2p-","frame":"style_frame__7Eow9","content":"style_content__EeYUs","crop":"style_crop__tp+uY"};